import { IconBuilder } from 'icon-sdk-js/build/icon-sdk-js.web.min.js';
import { iconService, scoreAddress } from '../defaultClient';
import { toHex } from '../common'

export const getStoreCount = async (customerId) => {
    const methodName = "getStoreCountOfCustomer";
    const call = callBuild(methodName, {
        customer_id: customerId
    })
    return iconService.call(call).execute();
}

export const getStores = async (customerId, i) => {
    const methodName = "getStoresOfCustomer";
    const call = callBuild(methodName, {
        customer_id: customerId,
        offset: toHex(i),
        count: toHex(1),
        is_include_info: toHex(true)
    })
    return iconService.call(call).execute();
}

export const getStore = async (owner) => {
    const methodName = "getStore";
    const call = callBuild(methodName, {
        owner: owner
    })
    return iconService.call(call).execute();;
}

export const getCustomer = async (customerId, storeOwner) => {
    const methodName = "getCustomer"
    const call = callBuild(methodName, {
        owner: storeOwner,
        customer_id: customerId
    })
    return iconService.call(call).execute();;
}

const callBuild = (methodName, params) => {
    const { CallBuilder } = IconBuilder
    return new CallBuilder()
        .to(scoreAddress)
        .method(methodName)
        .params(params)
        .build();
}